"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupForwardPlayerActions = void 0;
const wireProtocol_1 = require("~/plugins/wireProtocol");
const setupForwardPlayerActions = (startListening) => {
    startListening({
        predicate: (action) => wireProtocol_1.wireProtocol.acceptsOutbound(action.type),
        effect: (action, api) => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            (_a = api.extra.gameConnectionHolder
                .peek()) === null || _a === void 0 ? void 0 : _a.sendPlayerAction(action);
        }),
    });
};
exports.setupForwardPlayerActions = setupForwardPlayerActions;
